import React, { useState, useEffect } from "react";
import { Space, Typography, Radio, Checkbox } from "antd";
import i18n from "i18n";
import CustomModal from "components/CustomModal";
import { ImpressionPromptMode } from "../../constants";
import { LanguageModel, SelectableImpressionModel } from "api/sms-api";
import { connect } from "react-redux";
import { RootState } from "store/store";

interface SelectImpressionPromptModalProps {
  errors: any;
  visible: boolean;
  closeModal: () => void;
  currentOptions: {
    impressionPromptMode: ImpressionPromptMode;
    impressionPromptModels: string[];
  };
  languageModel: Array<LanguageModel>;
  selectableImpressionModels: Array<SelectableImpressionModel>;
  onSave: (options: {
    impressionPromptMode: ImpressionPromptMode;
    impressionPromptModels: string[];
  }) => void;
}

const { Paragraph } = Typography;

const SelectImpressionPromptModal: React.FC<SelectImpressionPromptModalProps> = ({
  visible,
  errors,
  closeModal,
  currentOptions,
  selectableImpressionModels,
  onSave,
}) => {
  const [localMode, setLocalMode] = useState<ImpressionPromptMode>(
    currentOptions.impressionPromptMode
  );
  const [localModels, setLocalModels] = useState<string[]>(
    currentOptions.impressionPromptModels
  );

  useEffect(() => {
    if (visible) {
      setLocalMode(currentOptions.impressionPromptMode);
      setLocalModels(currentOptions.impressionPromptModels);
    }
  }, [visible, currentOptions]);

  const handleCloseModal = async () => {
    if (errors.impressionPromptOptionsWithModels?.impressionPromptModels) {
      return;
    }
    closeModal();
  };

  const handleSave = () => {
    onSave({
      impressionPromptMode: localMode,
      impressionPromptModels: localModels,
    });
    closeModal();
  };

  const selectableModels = selectableImpressionModels.map((model) => ({
    label: model.name,
    value: model.selectableImpressionModelId,
  }));

  return (
    <CustomModal
      title={i18n.t("survey.selectImpressionPrompt")}
      okText={i18n.t("common.save")}
      visible={visible}
      closeModal={handleCloseModal}
      onOk={handleSave}
    >
      <Radio.Group
        value={localMode}
        onChange={(e) => setLocalMode(e.target.value)}
      >
        <Space direction="vertical">
          <Radio value={ImpressionPromptMode.Random}>
            {i18n.t("survey.impressionPromptMode.random")}
          </Radio>
          <Radio value={ImpressionPromptMode.Always}>
            {i18n.t("survey.impressionPromptMode.always")}
          </Radio>
        </Space>
      </Radio.Group>
      <Paragraph>{i18n.t("survey.selectImpressionPromptModel")}</Paragraph>
      <Checkbox.Group
        value={localModels}
        onChange={(checkedValues) => setLocalModels(checkedValues as string[])}
        options={selectableModels}
      />
    </CustomModal>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    languageModel: state.survey.languageModel,
    selectableImpressionModels: state.survey.selectableImpressionModels,
  };
};

export default connect(mapStateToProps)(SelectImpressionPromptModal);
